/* Generated by scripts/build-picker-icons.mjs. Do not edit directly. */
import type { PickerIconProps } from "../types.ts";

export function SymbolPrecisionManufacturingIcon({
  size = 24,
  color = "currentColor",
  title,
  ...svgProps
}: PickerIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      data-icon="symbol-precision-manufacturing"
      data-variant="filled"
      role={title ? "img" : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
      <path d="M5.3 21.95Q4.5 21.95 3.92 21.38Q3.35 20.8 3.35 20Q3.35 19.2 3.92 18.63Q4.5 18.05 5.3 18.05L6.47 18.05L4 9.53Q3.27 9.1 2.81 8.31Q2.35 7.53 2.35 6.65Q2.35 5.25 3.33 4.28Q4.3 3.3 5.7 3.3Q6.72 3.3 7.56 3.86Q8.4 4.42 8.78 5.3L11.75 5.3L11.75 4.6Q11.75 4.03 12.11 3.66Q12.47 3.3 13.05 3.3Q13.4 3.3 13.61 3.38Q13.82 3.45 14.05 3.6L14.05 3.6L15.75 1.95Q16.02 1.73 16.36 1.66Q16.7 1.6 17.05 1.75L21.1 3.6Q21.45 3.75 21.59 4.13Q21.73 4.5 21.55 4.85Q21.38 5.2 21.01 5.33Q20.65 5.45 20.3 5.3L16.75 3.7L14.4 5.95L14.4 7.3L16.75 9.55L20.3 7.95Q20.65 7.8 21.01 7.92Q21.38 8.05 21.55 8.4Q21.73 8.75 21.59 9.11Q21.45 9.47 21.1 9.65L17.05 11.6Q16.7 11.78 16.36 11.7Q16.02 11.63 15.75 11.35L14.05 9.7L14.05 9.7Q13.82 9.85 13.57 9.93Q13.32 10 13.05 10Q12.47 10 12.11 9.64Q11.75 9.28 11.75 8.7L11.75 7.95L8.75 7.95Q8.72 8.07 8.66 8.21Q8.6 8.35 8.5 8.45L13.7 18.05L15.25 18.05Q16.05 18.05 16.63 18.63Q17.2 19.2 17.2 20Q17.2 20.8 16.63 21.38Q16.05 21.95 15.25 21.95ZM5.7 7.35Q5.7 7.35 5.85 7.35Q6 7.35 6.2 7.15Q6.4 6.95 6.4 6.65Q6.4 6.35 6.2 6.15Q6 5.95 5.7 5.95Q5.4 5.95 5.2 6.15Q5 6.35 5 6.65Q5 6.95 5.2 7.15Q5.4 7.35 5.7 7.35Z" fill={color} />
    </svg>
  );
}
